import { render, staticRenderFns } from "./InsurancePayments.vue?vue&type=template&id=c5326832&scoped=true&"
import script from "./InsurancePayments.vue?vue&type=script&lang=js&"
export * from "./InsurancePayments.vue?vue&type=script&lang=js&"
import style0 from "./InsurancePayments.vue?vue&type=style&index=0&id=c5326832&prod&lang=css&"
import style1 from "./InsurancePayments.vue?vue&type=style&index=1&id=c5326832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5326832",
  null
  
)

export default component.exports